module.exports = __webpack_public_path__ + "static/media/lifeline_step_2_neg.b891dc26.png";